export default __webpack_public_path__ + "static/media/layout3.2a7adef5.svg";